import { Typography } from '@mui/material'
import React from 'react'
import {  useSelector } from 'react-redux';
import SelfCheckBox from '../Single Components/SelfCheckBox';

const LoginForm = ({onChangeFn, handleNextClick,clickLoginBtn, showForgotPassword, onForgotPasswordClick, loginLoading}) => {
 
  const { companyCode,userName,password } = useSelector((state) => state.loginFormNewSlice || {});
  const userRole = useSelector((state) => state.searchUserSlice.value);

  const isNextEnabled=!(userName===null || userName==="" || companyCode===null || companyCode==="")
  return (
    <>
  
    <div className='login-new-main-left-container'>
      <div className="login-text-container">
        <Typography fontSize={"2rem"} fontWeight={700} marginLeft={"24px"} className="login-text">
          Login
        </Typography>
        <Typography fontWeight={600} letterSpacing={1.4} marginLeft={"24px"} className="login-description">
          Restaurant Innovative ERP Solutions.
        </Typography>
      </div>
      <div className="login-new-form-container">
        <div className="login-form">
          <div className="user-name-container">
            <p>Company Code</p>
            <div className="login-new-username-wrapper">
              <input
                className="right-input-login-user"
                type={"text"}
                name="companyCode"
                id="companyCodeInput"
                value={companyCode || ""}
                onChange={onChangeFn}
              />
            </div>
           
            <p>User Name</p>
            <div className="login-new-username-wrapper">
              <input
                className="right-input-login-user"
                type={"text"}
                name="userName"
                id="userNameInput"
                value={userName || ""}
                onChange={onChangeFn}
                onKeyDown={(e) => {
                  e.key === "Enter" && handleNextClick();
                }}
              />
            </div>
            {userRole && (
                <div style={{position:"relative"}}>
                  <p>Password</p>
                  <div className="login-new-username-wrapper">
                    <input
                      className="right-input-login-user"
                      type="password"
                      name="password"
                      id="passwordInput"
                      value={password || ""}
                      onChange={onChangeFn}
                      onKeyDown={(e) => {
                        e.key === "Enter" && clickLoginBtn();
                      }}
                    />
                  </div>
                 {userRole?.enableSelfOrd && <SelfCheckBox/>}

                  <button
                    type="submit"
                    // className="login-btn btn-hide"
                    id="loginSubmitBtn"
                    className={password && !loginLoading ? "login-new-btn" : "login-btn-disabled"} 
                    disabled={password === "" || loginLoading}
                    onClick={clickLoginBtn}
                  >
                    {loginLoading ? 'Please wait…' : 'Login'}
                  </button>
                </div>
              )}
          </div>

          {!userRole && 
             <button
                disabled={!isNextEnabled}
                type="button"
                className={isNextEnabled ? "login-new-btn" : "login-btn-disabled"} 
                id="userNameNextBtn"
                onClick={handleNextClick}
              >
                Next
              </button>
        }

          <div className="login-new-content-wrapper-forgot-password-register">
            <a className="login-register-new-link" target="_blank" rel="noreferrer" href="https://thalipe.com/" style={{color:"#000"}}>Register here !</a>
            {showForgotPassword && userRole && (
              <p 
                onClick={onForgotPasswordClick}
                style={{
                  cursor: 'pointer',
                  color: '#FF6B6B',
                  fontWeight: 'bold',
                  textDecoration: 'underline'
                }}
              >
                Forgot password? Click here
              </p>
            )}
            {!showForgotPassword && <p style={{opacity: 0.5}}> Forgot password &gt;&gt;&gt;</p>}
          </div>
        </div>
      </div>
    </div>

   
    </>
  )
}

export default LoginForm